import type { FaireProductEntity } from "../../entity_types/product";

export const p_yuty8d3hca: FaireProductEntity = {
  token: "p_yuty8d3hca",
  type: "product",
  name: "Baby Wholesale Small Start Up Bundle",
  brandToken: "b_pbctwjfsgc",
  brandName: "Bubele",
  imageUrl: "https://cdn.faire.com/fastly/166dbded1626bd64e5530f65a95246a2aea5125a5864758739793b905234a885.png",
  galleryImageUrls: [],
  priceDollars: 192,
  description: "\nThis bundle is a quick and easy way to get started in your boutique with Bubele!\n\nIncludes a variety of sizes of:\n\n8 Bodysuits\n\n8 Pants\n\n8 Hats\n\nGet your small boutique booming with the Bubele Bundle - the ultimate kickstarter for any budding business. You'll find everything you need to turn heads and make a statement with these 8 outfits. It doesn't get any easier than this - just unbox and dive into the world of fashion!\n\n\n",
  tags: [],
  msrpDollars: 384,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:29.354Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
